/* DS forms — the website's enquiry forms, served from DS Portal (Enquiries).
   Runs on every page:
   1. Remembers where the visit came from (Google click IDs, UTM tags, visit times, session
      count, landing page, referrer) so an enquiry made later still carries them.
   2. Wherever a page has a form placeholder, draws that form and sends it to DS Portal.
      Placeholders: <div data-ds-form="quick-quote"></div>, or Globo's old
      {formbuilder:XXXX} short codes and <div class="globo-formbuilder" data-id="XXXX">,
      which are looked up by their Globo form id so nothing on the site had to change.
   Fields, wording and recipients all live in DS Portal > Enquiries > Configuration. */
(function () {
  'use strict';
  var API = (window.DS_FORMS_API || 'https://www.shockshop.com.au') + '/enquiries/api';
  var KEY = 'ds_trk';
  var SESSION_GAP = 30 * 60 * 1000;
  var CLICK = ['gclid', 'gbraid', 'wbraid', 'fbclid', 'msclkid'];
  var UTM = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  function load() { try { return JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) { return {}; } }
  function save(t) { try { localStorage.setItem(KEY, JSON.stringify(t)); } catch (e) { /* private window */ } }
  function stamp(d) {
    var p = function (n) { return (n < 10 ? '0' : '') + n; };
    return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate()) + ' ' + p(d.getHours()) + ':' + p(d.getMinutes());
  }

  /* ---------- 1. the visit ---------- */
  var now = new Date(), t = load(), q = new URLSearchParams(location.search);
  if (!t.first_seen) { t.first_seen = now.getTime(); t.first_visit = stamp(now); t.sessions = 0; }
  if (!t.last_seen || now.getTime() - t.last_seen > SESSION_GAP) {
    if (t.current_visit) t.last_visit = t.current_visit;
    t.current_visit = stamp(now);
    t.sessions = (t.sessions || 0) + 1;
    t.landing_page = location.href.slice(0, 500);
    var ref = document.referrer || '';
    t.referrer = ref && ref.indexOf(location.hostname) === -1 ? ref.slice(0, 500) : (t.sessions === 1 ? '' : t.referrer || '');
  }
  t.last_seen = now.getTime();
  var fresh = CLICK.concat(UTM).some(function (k) { return q.get(k); });
  if (fresh) {
    // A new ad click or tagged link replaces the last one, whole, so parts never mix.
    CLICK.concat(UTM).forEach(function (k) { delete t[k]; });
    CLICK.concat(UTM).forEach(function (k) { if (q.get(k)) t[k] = q.get(k).slice(0, 300); });
    t.click_at = stamp(now);
    if (!t.first_source) {
      t.first_source = q.get('utm_source') || (q.get('gclid') || q.get('gbraid') || q.get('wbraid') ? 'google' : q.get('fbclid') ? 'facebook' : '');
      t.first_campaign = q.get('utm_campaign') || '';
    }
  }
  if (!t.first_source && t.sessions === 1 && t.referrer) {
    try { t.first_source = new URL(t.referrer).hostname.replace(/^www\./, ''); } catch (e) { /* bad referrer */ }
  }
  save(t);

  /* ---------- 2. the forms ---------- */
  function gaClientId() {
    var m = document.cookie.match(/(?:^|;\s*)_ga=GA\d\.\d\.(\d+\.\d+)/);
    return m ? m[1] : '';
  }
  function vehicle() {
    try {
      var v = localStorage.getItem('VehicleSearchSelects');
      if (!v) return '';
      return v.split('|').filter(function (x) { return x && x.indexOf('/collections') !== 0; }).join(' ').trim();
    } catch (e) { return ''; }
  }
  function pageData() {
    var p = {};
    try { p = JSON.parse((document.getElementById('ds-page') || {}).textContent || '{}'); } catch (e) { p = {}; }
    p.url = location.href.slice(0, 500);
    p.title = document.title.slice(0, 300);
    p.vehicle = vehicle();
    if (p.product) {
      var id = new URLSearchParams(location.search).get('variant') ||
        ((document.querySelector('form[action*="/cart/add"] [name="id"]') || {}).value);
      var v = (p.product.variants || []).filter(function (x) { return String(x.id) === String(id); })[0] || (p.product.variants || [])[0];
      if (v) { p.product.sku = v.sku; p.product.variant = v.title === 'Default Title' ? '' : v.title; }
      delete p.product.variants;
    }
    return p;
  }

  var CSS = '.dsf{max-width:720px;margin:0 auto}.dsf-h{margin:0 0 14px}.dsf-g{display:grid;grid-template-columns:1fr 1fr;gap:14px 16px}' +
    '.dsf-f{display:flex;flex-direction:column;gap:6px;min-width:0}.dsf-w{grid-column:1/-1}.dsf label.dsf-l{font-weight:600;font-size:14px}' +
    '.dsf-r{color:#f1592a}.dsf input[type=text],.dsf input[type=email],.dsf input[type=tel],.dsf select,.dsf textarea{width:100%;box-sizing:border-box;border:1px solid #dcdcdc;border-radius:5px;padding:11px 12px;font:inherit;font-size:15px;background:#fff;color:#000}' +
    '.dsf textarea{min-height:120px;resize:vertical}.dsf input:focus,.dsf select:focus,.dsf textarea:focus{outline:2px solid #f1592a;outline-offset:0;border-color:#f1592a}' +
    '.dsf-c{display:flex;gap:10px;align-items:flex-start;font-size:14px;line-height:1.4}.dsf-c input{margin-top:3px;width:18px;height:18px;accent-color:#f1592a;flex:none}' +
    '.dsf-n{font-size:13px;color:#676767}.dsf-b{margin-top:18px;background:#f1592a;color:#fff;border:0;border-radius:5px;padding:13px 28px;font:inherit;font-weight:600;font-size:15px;cursor:pointer}' +
    '.dsf-b[disabled]{opacity:.6;cursor:wait}.dsf-e{margin-top:12px;color:#c62828;font-size:14px}.dsf-ok{padding:18px;border:1px solid #dcdcdc;border-left:4px solid #f1592a;border-radius:5px;background:#fff}' +
    '.dsf-hp{position:absolute!important;left:-9999px!important;width:1px;height:1px;overflow:hidden}' +
    '@media (max-width:749px){.dsf-g{grid-template-columns:1fr}}' +
    /* 3 Oct 2026: the forms as a card with a dark header, and request-type buttons (Ash: "forms need some style to gain attention") */
    '.dsf{max-width:760px;background:#fff;border:1px solid #ececec;border-radius:10px;box-shadow:0 8px 30px rgba(0,0,0,.08);overflow:hidden;padding:24px 0}.dsf>*:not(.dsf-top):not(.dsf-hp){margin-left:24px;margin-right:24px}.dsf>.dsf-b{width:calc(100% - 48px)}.dsf-top{background:#0f1a1f;color:#fff;padding:22px 24px 20px;position:relative;margin:-24px 0 20px}.dsf-top:before{content:\"\";position:absolute;left:0;top:0;right:0;height:4px;background:#f1592a}.dsf-top h2{color:#fff!important;margin:0;font-size:22px;font-weight:800;line-height:1.2}.dsf-top p{margin:6px 0 0;color:#cfd6d9;font-size:14px;line-height:1.5}.dsf-top a{color:#fff;font-weight:700}.dsf-q{font-size:12px;font-weight:700;letter-spacing:.7px;text-transform:uppercase;color:#676767;margin:0 0 10px}.dsf-chips{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:8px;margin-bottom:20px}.dsf-chip{display:flex;align-items:center;gap:10px;border:1.5px solid #e2e2e2;background:#fff;border-radius:8px;padding:11px 12px;font:inherit;font-weight:700;font-size:14px;text-align:left;cursor:pointer;color:#000;line-height:1.25}.dsf-chip i{flex:0 0 34px;height:34px;border-radius:8px;background:#f4f4f4;display:flex;align-items:center;justify-content:center;color:#111}.dsf-chip i svg{width:18px;height:18px}.dsf-chip.on{border-color:#f1592a;background:#fff5f1}.dsf-chip.on i{background:#f1592a;color:#fff}.dsf input[type=text],.dsf input[type=email],.dsf input[type=tel],.dsf select,.dsf textarea{border:1.5px solid #e2e2e2;border-radius:8px;padding:12px}.dsf label.dsf-l{font-weight:700;font-size:13px}.dsf-f[hidden]{display:none!important}.dsf-b{border-radius:8px;padding:15px 28px;font-weight:800;font-size:16px}@media (max-width:749px){.dsf>*:not(.dsf-top):not(.dsf-hp){margin-left:18px;margin-right:18px}.dsf>.dsf-b{width:calc(100% - 36px)}.dsf-top{padding:20px 18px 18px}}';
  var ICONS = { quote: '<path d="M12 2v20M17 6H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>', fit: '<path d="M14.7 6.3a4 4 0 0 0-5.4 5.4L3 18l3 3 6.3-6.3a4 4 0 0 0 5.4-5.4l-2.5 2.5-2.4-.6-.6-2.4z"/>', question: '<circle cx="12" cy="12" r="9"/><path d="M9.5 9a2.5 2.5 0 1 1 3.5 2.3c-.6.3-1 .9-1 1.6v.6M12 17h.01"/>', other: '<circle cx="5" cy="12" r="1.6"/><circle cx="12" cy="12" r="1.6"/><circle cx="19" cy="12" r="1.6"/>' };
  function iconFor(label) {
    var l = String(label).toLowerCase();
    var k = /quote|price|cost/.test(l) ? 'quote' : /fit|book|install/.test(l) ? 'fit' : /question|product|help|ask/.test(l) ? 'question' : 'other';
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + ICONS[k] + '</svg>';
  }
  var WIDE = { textarea: 1, checkbox: 1, file: 1, note: 1, radio: 1 };
  var n = 0;

  function el(tag, attrs, html) {
    var e = document.createElement(tag);
    for (var k in attrs || {}) if (attrs[k] !== null && attrs[k] !== undefined && attrs[k] !== false) e.setAttribute(k, attrs[k] === true ? '' : attrs[k]);
    if (html !== undefined) e.textContent = html;
    return e;
  }

  function draw(box, form) {
    var id = 'dsf' + (++n);
    var f = el('form', { class: 'dsf', novalidate: true, id: id });
    if (form.heading || form.tagline) {
      var top = el('div', { class: 'dsf-top' });
      if (form.heading) top.appendChild(el('h2', { class: 'dsf-h h3' }, form.heading));
      if (form.tagline) {
        var tl = el('p', {}, '');
        String(form.tagline).split(/(1300 ?66 ?29 ?20)/).forEach(function (part) {
          if (/^1300 ?66 ?29 ?20$/.test(part)) tl.appendChild(el('a', { href: 'tel:1300662920' }, part)); else tl.appendChild(document.createTextNode(part));
        });
        top.appendChild(tl);
      }
      f.appendChild(top);
    }
    /* Request types: the customer picks one, and each question shows only for the types it is set for */
    var topics = form.topics || [], topicIn = null;
    if (topics.length) {
      f.appendChild(el('p', { class: 'dsf-q' }, form.topic_label || 'What do you need?'));
      var chips = el('div', { class: 'dsf-chips', role: 'radiogroup' });
      topicIn = el('input', { type: 'hidden', name: '_topic', value: topics[0].k });
      topics.forEach(function (t, ti) {
        var cb = el('button', { type: 'button', class: 'dsf-chip' + (ti === 0 ? ' on' : ''), role: 'radio', 'aria-checked': ti === 0 ? 'true' : 'false', 'data-k': t.k });
        var ic = el('i', {}); ic.innerHTML = iconFor(t.label); cb.appendChild(ic);
        cb.appendChild(el('span', {}, t.label));
        chips.appendChild(cb);
      });
      f.appendChild(chips);
      f.appendChild(topicIn);
    }
    var g = el('div', { class: 'dsf-g' });
    var visible = form.fields.filter(function (x) { return x.type !== 'note'; });
    form.fields.forEach(function (x, i) {
      var wrap = el('div', { class: 'dsf-f' + (WIDE[x.type] || (x.type !== 'note' && visible.length % 2 && x === visible[visible.length - 1]) ? ' dsf-w' : '') });
      var fid = id + '-' + i, name = 'f_' + x.k;
      if (x.only && x.only.length) wrap.setAttribute('data-only', ' ' + x.only.join(' ') + ' ');
      if (x.type === 'note') { wrap.className = 'dsf-f dsf-w'; wrap.appendChild(el('p', { class: 'dsf-n' }, x.text)); g.appendChild(wrap); return; }
      if (x.type === 'checkbox') {
        var c = el('label', { class: 'dsf-c', for: fid });
        c.appendChild(el('input', { type: 'checkbox', id: fid, name: name, required: x.required }));
        c.appendChild(el('span', {}, x.label + (x.required ? ' *' : '')));
        wrap.appendChild(c); g.appendChild(wrap); return;
      }
      var lab = el('label', { class: 'dsf-l', for: fid }, x.label);
      if (x.required) lab.appendChild(el('span', { class: 'dsf-r' }, ' *'));
      wrap.appendChild(lab);
      var input;
      if (x.type === 'textarea') input = el('textarea', { id: fid, name: name, required: x.required, placeholder: x.placeholder || null, rows: 5 });
      else if (x.type === 'select' || x.type === 'radio') {
        input = el('select', { id: fid, name: name, required: x.required });
        input.appendChild(el('option', { value: '' }, x.placeholder || 'Please select'));
        (x.options || []).forEach(function (o) { input.appendChild(el('option', { value: o }, o)); });
      } else if (x.type === 'file') input = el('input', { type: 'file', id: fid, name: name, required: x.required, accept: '.pdf,.doc,.docx,.rtf,.txt,.jpg,.jpeg,.png,.heic,.webp' });
      else input = el('input', {
        type: x.type === 'tel' ? 'tel' : x.type === 'email' ? 'email' : 'text', id: fid, name: name, required: x.required,
        placeholder: x.placeholder || null,
        autocomplete: x.type === 'email' ? 'email' : x.type === 'tel' ? 'tel' : /^name$|business_name/.test(x.k) ? 'name' : null
      });
      wrap.appendChild(input);
      g.appendChild(wrap);
    });
    f.appendChild(g);
    function showFor(tk) {
      [].forEach.call(g.querySelectorAll('[data-only]'), function (w) {
        var on = !tk || w.getAttribute('data-only').indexOf(' ' + tk + ' ') >= 0;
        w.hidden = !on;
        [].forEach.call(w.querySelectorAll('input,select,textarea'), function (i) {
          if (i.hasAttribute('required')) i.setAttribute('data-req', '1');
          if (i.getAttribute('data-req')) { if (on) i.setAttribute('required', ''); else i.removeAttribute('required'); }
        });
      });
    }
    if (topicIn) {
      showFor(topicIn.value);
      f.querySelector('.dsf-chips').addEventListener('click', function (ev) {
        var cb = ev.target.closest ? ev.target.closest('.dsf-chip') : null;
        if (!cb) return;
        [].forEach.call(f.querySelectorAll('.dsf-chip'), function (x) { x.classList.toggle('on', x === cb); x.setAttribute('aria-checked', x === cb ? 'true' : 'false'); });
        topicIn.value = cb.getAttribute('data-k');
        showFor(topicIn.value);
      });
    }
    var hp = el('div', { class: 'dsf-hp', 'aria-hidden': 'true' });
    hp.appendChild(el('input', { type: 'text', name: '_hp', tabindex: '-1', autocomplete: 'off' }));
    f.appendChild(hp);
    var err = el('div', { class: 'dsf-e', role: 'alert' });
    var btn = el('button', { type: 'submit', class: 'dsf-b' }, form.submit || 'Submit');
    f.appendChild(btn);
    f.appendChild(err);
    var started = Date.now();

    f.addEventListener('submit', function (ev) {
      ev.preventDefault();
      err.textContent = '';
      var bad = [].filter.call(f.querySelectorAll('[required]'), function (i) {
        return i.type === 'checkbox' ? !i.checked : i.type === 'file' ? !i.files.length : !String(i.value || '').trim();
      });
      if (bad.length) { err.textContent = 'Please fill in the fields marked *.'; bad[0].focus(); return; }
      var em = f.querySelector('input[type=email]');
      if (em && em.value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em.value.trim())) { err.textContent = 'Please check your email address.'; em.focus(); return; }
      var size = [].reduce.call(f.querySelectorAll('input[type=file]'), function (s, i) { return s + [].reduce.call(i.files, function (a, x) { return a + x.size; }, 0); }, 0);
      if (size > 4 * 1024 * 1024) { err.textContent = 'Please keep files under 4MB in total.'; return; }
      var data = new FormData(f);
      data.append('_t', String(started));
      var trk = load();
      trk.ga_client_id = gaClientId();
      // the ad platforms' own cookies, kept with the enquiry so a sale can be sent back to them later (Meta fbp/fbc, Google and Microsoft click cookies)
      document.cookie.split('; ').forEach(function (c) { var i = c.indexOf('='), k = c.slice(0, i); if (/^(_fbp|_fbc|_gcl_aw|_gcl_gb|_gcl_au|_uetmsclkid)$/.test(k)) { try { trk[k.slice(1)] = decodeURIComponent(c.slice(i + 1)).slice(0, 300); } catch (e) { /* a bad cookie */ } } });
      data.append('_meta', JSON.stringify({ tracking: trk, page: pageData() }));
      btn.disabled = true;
      btn.textContent = 'Sending…';
      fetch(API + '/submit/' + encodeURIComponent(form.key), { method: 'POST', body: data })
        .then(function (r) { return r.json().catch(function () { return { ok: false }; }); })
        .then(function (j) {
          if (!j || !j.ok) throw new Error((j && j.error) || 'Something went wrong. Please call us on 1300 66 29 20.');
          var done = el('div', { class: 'dsf-ok globo-form', role: 'status' });
          done.appendChild(el('p', { class: 'message success', style: 'margin:0;font-weight:600' }, j.message || form.success || 'Thanks, we will be in touch soon.'));
          f.replaceWith(done);
          // The event names Globo used, so GTM triggers and Ads conversions keep counting.
          var detail = { event: 'globo_form_submit', formId: form.legacy || form.key, form_key: form.key, eventCategory: 'Form Submission Globo', eventAction: 'Submit', eventLabel: form.label };
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push(detail);
          window.dataLayer.push({ event: 'ds_form_submit', form_key: form.key, form_label: form.label });
          if (typeof window.gtag === 'function') window.gtag('event', 'globo_form_submit', { event_category: 'Form Submission Globo', event_action: 'Submit', event_label: form.label });
          document.dispatchEvent(new CustomEvent('ds:form-submitted', { detail: { key: form.key } }));
        })
        .catch(function (e) {
          err.textContent = e.message;
          btn.disabled = false;
          btn.textContent = form.submit || 'Submit';
        });
    });

    box.textContent = '';
    box.appendChild(f);
  }

  function mount(box, key) {
    if (box.getAttribute('data-ds-ready')) return;
    box.setAttribute('data-ds-ready', '1');
    /* 3 Oct 2026 (Ash: "contact form doesn't load fast"): draw the copy kept on this device straight away, then
       check DS Portal in the background and redraw only if the form changed and nothing has been typed yet. */
    var ck = 'ds_form_' + key, cached = null;
    try { cached = JSON.parse(localStorage.getItem(ck) || 'null'); } catch (e) { cached = null; }
    if (cached && cached.form) draw(box, cached.form);
    var typed = function () { return [].some.call(box.querySelectorAll('input,textarea'), function (x) { return x.type !== 'hidden' && x.type !== 'checkbox' && String(x.value || '').trim(); }); };
    fetch(API + '/form/' + encodeURIComponent(key))
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (!(j && j.ok)) { if (!cached) box.textContent = ''; return; }
        try { localStorage.setItem(ck, JSON.stringify({ at: Date.now(), form: j.form })); } catch (e) { /* private window */ }
        if (!cached || (JSON.stringify(cached.form) !== JSON.stringify(j.form) && !typed())) draw(box, j.form);
      })
      .catch(function () { if (!cached) box.textContent = 'This form could not load. Please call us on 1300 66 29 20.'; });
  }

  function globoKey(b64) {
    try { var id = atob(String(b64).trim()); return /^\d+$/.test(id) ? 'g' + id : ''; } catch (e) { return ''; }
  }

  function scan() {
    var boxes = [].slice.call(document.querySelectorAll('[data-ds-form]:not([data-ds-ready])'));
    boxes.forEach(function (b) { mount(b, b.getAttribute('data-ds-form')); });
    [].forEach.call(document.querySelectorAll('.globo-formbuilder[data-id]:not([data-ds-ready])'), function (b) {
      var k = globoKey(b.getAttribute('data-id'));
      if (k) mount(b, k);
    });
    if (document.body.innerHTML.indexOf('{formbuilder:') === -1) return;
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        return node.nodeValue.indexOf('{formbuilder:') !== -1 && !(node.parentNode && /^(SCRIPT|STYLE|TEXTAREA)$/.test(node.parentNode.nodeName))
          ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var hits = [], node;
    while ((node = walker.nextNode())) hits.push(node);
    hits.forEach(function (tn) {
      var parts = tn.nodeValue.split(/(\{formbuilder:[A-Za-z0-9+/=]+\})/);
      var frag = document.createDocumentFragment();
      parts.forEach(function (part) {
        var m = part.match(/^\{formbuilder:([A-Za-z0-9+/=]+)\}$/);
        if (!m) { if (part) frag.appendChild(document.createTextNode(part)); return; }
        var box = el('div', { class: 'ds-form' });
        frag.appendChild(box);
        var k = globoKey(m[1]);
        if (k) mount(box, k);
      });
      tn.parentNode.replaceChild(frag, tn);
    });
  }

  if (!document.getElementById('dsf-css')) {
    var st = el('style', { id: 'dsf-css' });
    st.textContent = CSS;
    (document.head || document.documentElement).appendChild(st);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  // Sections the theme re-renders (quick view, product swaps) can bring a form in later.
  document.addEventListener('shopify:section:load', scan);
})();
